<template>
    <form class="flex flex-col space-y-5 mx-auto max-w-2xl w-full" @submit.prevent="submitForm">
        <InsuranceBlock :product="product" :type="type" />

        <div class="border w-full"></div>
        
        <AffInput required v-model="imei" label="IMEI du téléphone" />
        <input type="submit" :disabled="!isValid" value="Enregistrer l'IMEI" class="p-4 px-8 cursor-pointer bg-green-500 hover:bg-green-600 text-white rounded ml-auto disabled:opacity-75 disabled:cursor-not-allowed"/>
    </form>
</template>

<script>
import InsuranceBlock from '@/components/enrolment/InsuranceBlock'
import AffInput from '@/components/inputs/AffInput'

export default {
    components: { InsuranceBlock, AffInput },
    props: ['product', 'type'],
    data: function () {
        return {
            imei: null
        }
    },
    mounted: function () {
        if(this.product && this.product.imei) {
            this.imei = this.product.imei;
        }
    },
    computed: {
        isValid: function () {
            return this.imei;
        }
    },
    methods: {
        submitForm: function () {
            this.$emit('validate-imei', this.imei);
        }
    }
}
</script>